import { render, staticRenderFns } from "./RamadanCategoryContent.vue?vue&type=template&id=c18213c4&scoped=true"
import script from "./RamadanCategoryContent.vue?vue&type=script&lang=js"
export * from "./RamadanCategoryContent.vue?vue&type=script&lang=js"
import style0 from "./RamadanCategoryContent.vue?vue&type=style&index=0&id=c18213c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18213c4",
  null
  
)

export default component.exports